import React from "react";

import currencyFormatter from "../../../helpers/currencyFormatter";
import { formatTripDate } from "../../../helpers/dates";
import formatStage from "../../../helpers/format-stage";
import { isContractStageIncomplete as isIncompleteStage } from "./verification-status";

const formatDate = (date) => (date ? formatTripDate(date, "M/D/YYYY") : "N/A");

const legRouting = (leg) =>
  leg ? `${leg.departureAirport?.code} - ${leg.arrivalAirport?.code}` : "-";

const formatDates = (legs = []) => {
  if (!legs.length) return "N/A";
  if (legs.length === 1) return formatDate(legs[0].departureDate);
  return `${formatDate(legs[0].departureDate)} - ${formatDate(
    legs[legs.length - 1].departureDate,
  )}`;
};

const formatAircraft = (legs = []) => {
  const names = legs.map((l) => l.aircraft?.name).filter(Boolean);
  if (!names.length) return "N/A";
  const first = names[0];
  const extra = new Set(names.slice(1).filter((n) => n !== first)).size;
  return extra > 0 ? `${first} (+${extra})` : first;
};

const openL2 = (path) => window.open(path, "_blank", "noopener,noreferrer");

const ContractsBlock = ({ tripId, trip, readOnly }) => {
  const contracts = trip?.contractData || [];
  const hasIncomplete = contracts.some((c) => isIncompleteStage(c.stage));

  return (
    <div className="tv-block tv-contracts">
      <div className="tv-block-header">
        <h5 className="tv-block-title">
          Contracts
          {hasIncomplete && (
            <span className="tv-text-danger"> - Incomplete</span>
          )}
        </h5>
        {!readOnly && (
          <div className="tv-block-actions">
            <button
              type="button"
              className="base-button icon-button icon-button-small evo-blue"
              onClick={() => openL2(`/trips/${tripId}?tab=contract`)}
              title="Add New Contract"
            >
              <span className="material-icons">add_circle</span>
            </button>
          </div>
        )}
      </div>

      <div className="tv-block-body">
        {contracts.length === 0 ? (
          <div className="tv-empty">No contracts are available.</div>
        ) : (
          <table className="tv-table">
            <thead>
            <tr>
              <th>View</th>
              <th>Dates</th>
              <th>Aircraft</th>
              <th>First Leg</th>
              <th>Last Leg</th>
              <th>Charges</th>
              <th>Stage</th>
            </tr>
            </thead>
            <tbody>
            {contracts.map((contract) => {
              const legs = contract.legs || [];
              return (
                <tr key={contract._id}>
                  <td>
                    <a
                      href={`/trips/${tripId}/contracts/${contract._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {contract.contractTag}
                    </a>
                  </td>
                  <td>{formatDates(legs)}</td>
                  <td>{formatAircraft(legs)}</td>
                  <td>{legRouting(legs[0])}</td>
                  <td>{legs.length > 1 ? legRouting(legs[legs.length - 1]) : "-"}</td>
                  <td>{currencyFormatter.format(contract.pricing?.flightCharges || 0)}</td>
                  <td
                    className={
                      isIncompleteStage(contract.stage) ? "tv-text-danger" : ""
                    }
                  >
                    {formatStage(contract.stage)}
                  </td>
                </tr>
              );
            })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ContractsBlock;
